'use strict';

import React from 'react';
import PropTypes from 'prop-types';

import appConstants from 'constants/appConstants';

import teamActions from 'actions/TeamActionCreators';
import teamStore from 'stores/TeamStore';
import PageSection from 'components/base/PageSection';
import WidgetButton from 'components/base/WidgetButton';

import _ from 'underscore';
import utils from 'services/utils';
import constants from 'constants/appConstants';
import moment from 'moment';

const propTypes = {
    error: PropTypes.bool,
    className: PropTypes.string,
    id: PropTypes.string,
};

class AllTeamMembersButtonWidget extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {

        var isInUnassigned = _.find(this.props.person.Memberships, function (membership) {
            return membership.Team.IsDefaultTeam === true;
        });

        var numberOfTeams = this.props.person.Memberships.length - (isInUnassigned ? 1 : 0);
        
        return (
            <PageSection
                id="all-team-members-widget"
                hideSection={numberOfTeams <= 1}
                backgroundColorClass="background-color-info"
                halfSize
                link="/teams/my-teams/"
            >
                <WidgetButton heading="All Team Members" iconName="icon-team-members" />
            </PageSection>
        );
    }
}

AllTeamMembersButtonWidget.propTypes = propTypes;

export default AllTeamMembersButtonWidget; 